module.exports = __webpack_public_path__ + "img/kehu.0ab3c58a.jpg";